import { createFileRoute } from '@tanstack/react-router';

import { UserCreatePage } from './-components/UserCreatePage';

export const Route = createFileRoute('/_authenticated/users/new')({
    component: UserCreatePage,
});
